import { render, staticRenderFns } from "./ModalImportarPedido.vue?vue&type=template&id=00afeaeb&"
import script from "./ModalImportarPedido.vue?vue&type=script&lang=js&"
export * from "./ModalImportarPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports